export default __webpack_public_path__ + "static/media/container_tracking-skyblue.c916fe9c.svg";